var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.outdatedCacheModal
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function fn() {
          return [_vm._v(" Page Outdated ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm._v(
              " Your cache is outdated. Please refresh this page to clear your cache. This dialog will go away once your local cache is cleared and updated. "
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }